export function sanitise(html) {
    if (!html) return '';

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    // Whitelist of safe text-based tags
    const allowedTags = [
        'p', 'br', 'b', 'i', 'strong', 'em', 'ul', 'ol', 'li',
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span', 'div', 'a', 'u',
        'table', 'thead', 'tbody', 'tfoot', 'tr', 'th', 'td', 'caption', 'hr',
    ];

    const allowedProtocols = ['http:', 'https:', 'mailto:', 'tel:'];

    const allElements = Array.from(doc.body.querySelectorAll('*'));

    allElements.forEach(node => {
        const tagName = node.tagName.toLowerCase();

        // Remove banned tags
        if (!allowedTags.includes(tagName)) {
            while (node.firstChild) {
                node.parentNode.insertBefore(node.firstChild, node);
            }
            node.remove();
            return;
        }

        // Clean attributes
        const attrs = node.attributes;
        for (let i = attrs.length - 1; i >= 0; i--) {
            const name = attrs[i].name.toLowerCase();
            const value = attrs[i].value;

            // Only allow 'href' on 'a' tags, and block javascript:/data: protocols
            if (tagName === 'a' && name === 'href') {
                const normalizedValue = value.toLowerCase().replace(/[\s\x00-\x1F\x7F-\x9F]/g, '');
                const hasAllowedProtocol = allowedProtocols.some(proto => normalizedValue.startsWith(proto));
                const isRelative = /^[/#.]/.test(normalizedValue);

                if (hasAllowedProtocol || isRelative) {
                    node.setAttribute('rel', 'noopener noreferrer');
                    node.setAttribute('target', '_blank');
                } else {
                    // Block everything else (javascript:, data:, etc.)
                    node.removeAttribute(name);
                }
            } else {
                node.removeAttribute(name);
            }
        }
    });

    return doc.body.innerHTML;
}